import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/shared/ProtectedRoute";

import Landing from "@/pages/public/Landing";
import DealerLogin from "@/pages/DealerLogin";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminProductForm from "@/pages/admin/ProductForm";
import AdminCollections from "@/pages/admin/Collections";
import AdminQualities from "@/pages/admin/Qualities";
import AdminCompanies from "@/pages/admin/Companies";
import AdminCompanyForm from "@/pages/admin/CompanyForm";
import AdminOrders from "@/pages/admin/Orders";
import AdminOrderDetail from "@/pages/admin/OrderDetail";
import AdminStock from "@/pages/admin/Stock";
import AdminReports from "@/pages/admin/Reports";
import AdminSettings from "@/pages/admin/Settings";

import DealerLayout from "@/pages/dealer/DealerLayout";
import DealerDashboard from "@/pages/dealer/Dashboard";
import DealerProducts from "@/pages/dealer/Products";
import DealerProductDetail from "@/pages/dealer/ProductDetail";
import DealerOrders from "@/pages/dealer/Orders";
import DealerOrderDetail from "@/pages/dealer/OrderDetail";
import DealerProfile from "@/pages/dealer/Profile";

function FontInjector() {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href =
      "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;600&family=Outfit:wght@300;400;500;600;700&display=swap";
    document.head.appendChild(link);
  }, []);
  return null;
}

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/bayi-girisi" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/bayi"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <FontInjector />
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton theme="light" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/bayi-girisi" element={<DealerLogin />} />
          <Route path="/giris" element={<RoleHome />} />

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="urunler" element={<AdminProducts />} />
            <Route path="urunler/yeni" element={<AdminProductForm />} />
            <Route path="urunler/:id" element={<AdminProductForm />} />
            <Route path="koleksiyonlar" element={<AdminCollections />} />
            <Route path="kaliteler" element={<AdminQualities />} />
            <Route path="firmalar" element={<AdminCompanies />} />
            <Route path="firmalar/yeni" element={<AdminCompanyForm />} />
            <Route path="firmalar/:id" element={<AdminCompanyForm />} />
            <Route path="siparisler" element={<AdminOrders />} />
            <Route path="siparisler/:id" element={<AdminOrderDetail />} />
            <Route path="stok" element={<AdminStock />} />
            <Route path="raporlar" element={<AdminReports />} />
            <Route path="ayarlar" element={<AdminSettings />} />
          </Route>

          <Route
            path="/bayi"
            element={
              <ProtectedRoute role="dealer">
                <DealerLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DealerDashboard />} />
            <Route path="urunler" element={<DealerProducts />} />
            <Route path="urunler/:id" element={<DealerProductDetail />} />
            <Route path="siparislerim" element={<DealerOrders />} />
            <Route path="siparislerim/:id" element={<DealerOrderDetail />} />
            <Route path="profil" element={<DealerProfile />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
